<template>
  <a
    id="inline-banner"
    href="https://365datascience.com/career-quiz/?utm_medium=web&utm_source=statisticscalculators&utm_campaign=inline-banner-career-quiz"
    target="_blank"
    class="quiz-banner no-hover"
    data-banner-content="career-quiz"
  >
    <div class="desktop">
      <div class="left-wrapper">
        <p>
          Statistics is just the start.  <span class="first">What’s next?</span><br><span class="second">FREE CAREER QUIZ</span> <br> Find your perfect job in <span class="third">AI and data.</span>
        </p>
      </div>
      <div class="right-wrapper">
        <Logo />
        <button class="take-btn btn-primary">
          Take quiz
        </button>
      </div>
    </div>
    <div class="mobile">
      <Logo />
      <p class="first">
        Statistics is just the start. <br><span>What’s next?</span>
      </p>
      <p class="second">
        FREE CAREER QUIZ
      </p>
      <p>
        Find your perfect job in <strong>AI and data.</strong>
      </p>
      <button class="take-btn btn-primary">
        Take quiz
      </button>
    </div>
  </a>
</template>

<script>
import Logo from '@itbpbg/lms-components/src/assets/svg/365-logo-v2.svg?vue-component';

export default {
  components: {
    Logo,
  },
};
</script>

<style lang="scss" scoped>
.quiz-banner {
  background-image: url('../assets/images/quiz-banner.webp');
  padding: 32px 85px;
  border-radius: 24px;
  margin-top: var(--spacing-60);
  display: block;
  color: var(--main-dark-shade-0);

  .mobile {
    display: none;
  }

  .desktop {
    display: flex;
    justify-content: space-between;
  }

  .left-wrapper {
    p {
      margin: 0;
      font-weight: 500;

      .first {
        font-size: 18px;
        line-height: 150%;
        font-weight: 700;
        text-transform: uppercase;
      }

      .second {
        font-size: 36px;
        font-weight: 700;
        line-height: 110%;
      }

      .third {
        font-weight: 600;
      }
    }
  }

  .right-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    svg {
      width: 165px;
    }

    .take-btn {
      width: 225px;
      height: 52px;
      margin-top: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

@include bp($bp-mobile) {
  .quiz-banner {
    background-image: url('../assets/images/quiz-banner-mobile.webp');
    padding: 24px;
    margin-top: var(--spacing-40);
    border-radius: 0;
    background-repeat: no-repeat;
    background-size: cover;

    .desktop {
      display: none;
    }

    .mobile {
      display: block;
      text-align: center;
    }

    svg {
      width: 137px;
      height: 20px;
      margin-bottom: 20px;
    }

    p {
      margin: 0;
      font-weight: 500;
    }

    .first {
      line-height: 150%;
      span {
        font-size: 18px;
        font-weight: 700;
      }
    }

    .second {
      margin: 12px 0;
      font-size: 32px;
      font-weight: 700;
    }

    .take-btn {
      margin-top: 20px;
      height: 52px;
      width: 100%;
    }
  }
}
</style>
